const initialState = {
    error: null,
    loaded: false,
    data: {},
};
export default initialState;
